export default function IconSymbolIT(props) {
  return (
    <svg width="16" height="16" viewBox="-55 -55 110 110" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" {...props}>
      <circle cx="0" cy="0" r="50"/><line x1="-17.7" y1="-19.8" x2="-17.7" y2="19.8"/><line x1="-21.7" y1="-19.8" x2="-13.7" y2="-19.8"/><line x1="-21.7" y1="19.8" x2="-13.7" y2="19.8"/><line x1="2.0" y1="-19.8" x2="26.3" y2="-19.8"/><line x1="14.1" y1="-19.8" x2="14.1" y2="19.8"/>
    </svg>
  )
}
